import { Routes } from '@angular/router';
import { authGuard } from '@app/shared/guards/auth.guard';
import { profileGuard } from '@app/shared/guards/profile.guard';
import { guestOnlyGuard } from '@app/shared/guards/guest-only.guard';
import { forceUpdateGuard } from '@app/shared/guards/force-update.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'force-update',
    loadComponent: () =>
      import('@app/features/force-update/force-update.page').then(
        (m) => m.ForceUpdatePage
      ),
    data: {
      title: 'アップデート',
      meta: {
        description: 'アプリのアップデートが必要です',
        keywords: 'アップデート, 強制更新',
      },
    },
  },
  {
    path: 'maintenance',
    loadComponent: () =>
      import('@app/features/maintenance/maintenance.page').then(
        (m) => m.MaintenancePage
      ),
    data: {
      title: 'メンテナンス中',
      meta: {
        description: 'システムメンテナンス中です',
        keywords: 'メンテナンス, 一時停止',
      },
    },
    canActivate: [forceUpdateGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('@app/features/welcome/welcome.page').then((m) => m.WelcomePage),
    canActivate: [forceUpdateGuard, guestOnlyGuard],
    data: { title: 'ようこそ' },
  },
  {
    path: 'tabs',
    loadComponent: () =>
      import('@app/features/tabs/tabs.page').then((m) => m.TabsPage),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('@app/features/home/home.page').then((m) => m.HomePage),
        data: {
          title: 'ホーム',
          breadcrumb: 'ホーム',
          meta: {
            description: 'ゲーム',
            keywords: 'ホーム',
          },
        },
      },
      {
        path: 'my-page',
        loadComponent: () =>
          import('@app/features/my-page/my-page.page').then(
            (m) => m.MyPagePage
          ),
        canActivate: [forceUpdateGuard, profileGuard],
        data: {
          title: 'ホーム',
          breadcrumb: 'ホーム',
          meta: {
            description: 'ゲーム',
            keywords: 'ホーム',
          },
        },
      },
      {
        path: 'mail',
        loadChildren: () => import('@app/features/mail/mail.routes'),
        canActivate: [forceUpdateGuard, profileGuard],
        data: {
          title: 'メール一覧',
          breadcrumb: 'メール',
          meta: {
            description: 'メール一覧',
            keywords: 'メール',
          },
        },
      },
      {
        path: 'diary',
        loadChildren: () => import('@app/features/diary/diary.routes'),
        canMatch: [authGuard],
        canActivate: [forceUpdateGuard, profileGuard],
        data: {
          title: '日記一覧',
          breadcrumb: '日記一覧',
          meta: {
            description: '日記一覧',
            keywords: '日記一覧',
          },
        },
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'user-profile',
    loadChildren: () =>
      import('@app/features/user-profile/user-profile.routes').then(
        (m) => m.default
      ),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: 'ユーザープロフィール',
      breadcrumb: 'プロフィール',
      meta: {
        description: 'プロフィール管理',
        keywords: 'プロフィール, 管理',
      },
    },
  },
  {
    path: 'mail',
    loadChildren: () => import('@app/features/mail/mail.routes'),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: 'メール一覧',
      breadcrumb: 'メール一覧',
      meta: {
        description: 'メール一覧',
        keywords: 'メール一覧',
      },
    },
  },
  {
    path: 'notification',
    loadChildren: () =>
      import('@app/features/notification/notification.routes'),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard, profileGuard],
    data: {
      title: '通知一覧',
      breadcrumb: '通知一覧',
      meta: {
        description: '通知一覧',
        keywords: '通知, お知らせ',
      },
    },
  },
  {
    path: 'setting',
    loadChildren: () => import('@app/features/setting/setting.routes'),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: '設定',
      breadcrumb: '設定',
      meta: {
        description: 'アプリの設定',
        keywords: '設定, アプリ設定',
      },
    },
  },
  {
    path: 'auth',
    loadChildren: () => import('@app/features/auth/auth.routes'),
    canActivate: [forceUpdateGuard],
    data: {
      title: '認証',
      breadcrumb: '認証',
      meta: {
        description: '認証ページ',
        keywords: 'ログイン, サインアップ, 認証',
      },
    },
  },
  {
    path: 'user',
    loadChildren: () => import('@app/features/user/user.routes'),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: 'ユーザー',
      breadcrumb: 'ユーザー',
      meta: {
        description: 'ユーザープロフィール',
        keywords: 'ユーザー, プロフィール, 設定',
      },
    },
  },
  {
    path: 'setup',
    loadChildren: () => import('@app/features/setup/setup.routes'),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: '認証',
      breadcrumb: '認証',
      meta: {
        description: '初期設定',
        keywords: '初期設定, セットアップ',
      },
    },
  },
  {
    path: 'search',
    loadChildren: () => import('@app/features/search/search.routes'),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: '検索',
      breadcrumb: '検索',
      meta: {
        description: '検索ページ',
        keywords: '検索, 検索機能',
      },
    },
  },
  {
    path: 'footprint',
    loadChildren: () =>
      import('@app/features/profile-footprint/profile-footprint.routes'),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: '足跡',
      breadcrumb: '足跡',
      meta: {
        description: '足跡一覧',
        keywords: '足跡, プロフィール, フットプリント',
      },
    },
  },
  {
    path: 'point-history',
    loadChildren: () =>
      import('@app/features/point-history/point-history.routes'),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: 'ポイント履歴',
      breadcrumb: 'ポイント履歴',
      meta: {
        description: 'ポイント一覧',
        keywords: 'ポイント',
      },
    },
  },
  {
    path: 'point-consumption',
    loadChildren: () =>
      import('@app/features/point-consumption/point-consumption.routes'),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: 'ポイント消費一覧',
      breadcrumb: 'ポイント消費一覧',
      meta: {
        description: 'ポイント消費一覧',
        keywords: 'ポイント, 消費',
      },
    },
  },
  {
    path: 'exchange',
    loadChildren: () => import('@app/features/exchange/exchange.routes'),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: 'ポイント・ギフト',
      breadcrumb: 'ポイント・ギフト',
      meta: {
        description: 'ポイント・ギフト',
        keywords: 'ポイント・ギフト',
      },
    },
  },
  {
    path: 'payment/result',
    loadComponent: () =>
      import('@app/features/payment/result/payment-result.page').then(
        (m) => m.PaymentResultPage
      ),
    canMatch: [authGuard],
    canActivate: [forceUpdateGuard],
    data: {
      title: '決済結果',
      breadcrumb: '決済結果',
      meta: {
        description: '決済結果',
        keywords: '決済, 結果',
      },
    },
  },
  {
    path: 'member/email-change',
    loadComponent: () =>
      import('@app/features/email-change/email-change.page').then(
        (m) => m.EmailChangePage
      ),
    canActivate: [forceUpdateGuard],
    data: {
      title: 'メールアドレスの変更',
      breadcrumb: 'メール変更',
    },
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('@app/features/contact/contact.page').then((m) => m.ContactPage),
    canActivate: [forceUpdateGuard],
    data: {
      title: 'お問い合わせ',
      breadcrumb: 'お問い合わせ',
    },
  },
  {
    path: 'info/identity',
    loadComponent: () =>
      import('@app/features/setting/age-verification/age-verification.page').then(
        (m) => m.AgeVerificationPage
      ),
    // 未ログインでも説明のみ表示するため authGuard を付けない
    canActivate: [forceUpdateGuard],
    data: {
      title: '年齢認証',
      breadcrumb: '年齢認証',
    },
  },
  {
    path: 'info/:type',
    loadComponent: () =>
      import('@app/features/info/info.page').then((m) => m.InfoPage),
    // 利用規約・プライバシー等は未ログインでも表示するため authGuard を付けない
    canActivate: [forceUpdateGuard],
    data: {
      title: '情報ページ',
      breadcrumb: '情報',
    },
  },
  {
    path: 'csae',
    loadComponent: () =>
      import('@app/features/csae/csae.page').then((m) => m.CsaePage),
    canActivate: [forceUpdateGuard],
    data: {
      title: '児童の性的虐待と搾取（CSAE）に対するポリシー',
      breadcrumb: 'CSAE',
    },
  },
  {
    path: '**',
    redirectTo: '',
  },
];
